<template>
  <cockpit-dialog
    title="监控画面"
    width="1000px"
    height="500px"
    top="220px"
    left="460px"
    cardType="horizontal"
    @close="closeDialog"
  >
    <YSPlayerControl :code="code" :pIid="pIid" class="w-full h-full"></YSPlayerControl>
  </cockpit-dialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const YSPlayerControl = () => {
  return import('../../components/video/YSPlayer/YSPlayerControl')
}

export default {
  components: { CockpitDialog, YSPlayerControl },
  props: {
    code: {
      type: String,
    },
    pIid: {
      type: String,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style></style>
